import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface INewMessageRequest extends IBaseRequest {
  numberOfAttachments?: number;
  identity?: string;
  priority?: number;
  customType?: number;
  type?: number;
  mailFrom?: string;
  mailId?: string;
  templateAclh?: string;
  treeHandle?: number;
  group?: string;
  parent?: string;
  mobile?: string;
  status?: string;
  doNotMoveThread?: string;
  isSpam?: string;
  star?: string;
  threadId?: string;
  contextId?: string;
  remoteId?: string;
  schedulerId?: number;
  invoiceId?: string;
  INCLUDEMSG?: Includemsg;
  SUBJECT?: Comment;
  RECIPIENT?: Recipient;
  COMMENT?: Comment;
  HTML?: Comment;
  DOCUMENT?: Document;
  CONTACT_RELATIONS?: ContactRelations;
}
export interface Comment {
  string?: string;
}
function toCommentXml(c: Comment, proprtyName: string): string {
  if (c.string) return `<${proprtyName}><string>${c.string}</string></${proprtyName}>`;
  return ``;
}

export interface ContactRelations {
  CONTACT_RELATION?: ContactRelation[];
}
function toContactRelationsXml(c: ContactRelations): string {
  return `<CONTACT_RELATIONS>
    ${c.CONTACT_RELATION ? c.CONTACT_RELATION.map(toContactRelationXml).join('\n') : ''}
    </CONTACT_RELATIONS>`;
}

export interface ContactRelation {
  type?: string;
  identifier?: string;
  contact?: string;
}
function toContactRelationXml(c: ContactRelation): string {
  let info = '';

  if (c.type) info += `<type>${c.type}</type>`;
  if (c.identifier) info += `<identifier>${c.identifier}</identifier>`;
  if (c.contact) info += `<contact>${c.contact}</contact>`;

  return `<CONTACT_RELATION>${info}</CONTACT_RELATION>`;
}

export interface Document {
  ITEM?: Item[];
}
function toDocumentXml(d: Document): string {
  return `<DOCUMENT>
    ${d.ITEM ? d.ITEM.map(toItemXml).join('\n') : ''}
    </DOCUMENT>`;
}

export interface Item {
  createdByName?: string;
  id?: string;
  lastChangeDate?: string;
  name?: string;
}
function toItemXml(i: Item): string {
  let info = '';

  if (i.createdByName) info += `<createdByName>${i.createdByName}</createdByName>`;
  if (i.id) info += `<id>${i.id}</id>`;
  if (i.lastChangeDate) info += `<lastChangeDate>${i.lastChangeDate}</lastChangeDate>`;
  if (i.name) info += `<name>${i.name}</name>`;

  return `<ITEM>${info}</ITEM>`;
}

export interface Includemsg {
  includeMessage?: string;
  includeMsgText?: string;
}
function toIncludemsgXml(i: Includemsg): string {
  let info = '';

  if (i.includeMessage) info += `<includeMessage>${i.includeMessage}</includeMessage>`;
  if (i.includeMsgText) info += `<includeMsgText>${i.includeMsgText}</includeMsgText>`;

  return `<INCLUDEMSG>${info}</INCLUDEMSG>`;
}

export interface Recipient {
  TO?: Bcc[];
  CC?: Bcc[];
  BCC?: Bcc[];
  USER?: Bcc[];
}
function toRecipientXml(r: Recipient): string {
  let info = '';

  if (r.TO) info += r.TO.map(b => toBccXml(b, 'TO')).join('\n');
  if (r.CC) info += r.CC.map(b => toBccXml(b, 'CC')).join('\n');
  if (r.BCC) info += r.BCC.map(b => toBccXml(b, 'BCC')).join('\n');
  if (r.USER) info += r.USER.map(b => toBccXml(b, 'USER')).join('\n');

  return `<RECIPIENT>${info}</RECIPIENT>`;
}

export interface Bcc {
  CONTENT?: string;
  salutation?: string;
  contactName?: string;
  id?: string;
}
function toBccXml(b: Bcc, proprtyName: string): string {
  let info = '';

  if (b.CONTENT) info += `<CONTENT>${b.CONTENT}</CONTENT>`;
  if (b.salutation) info += `<salutation>${b.salutation}</salutation>`;
  if (b.contactName) info += `<contact>${b.contactName}</contact>`;
  if (b.id) info += `<id>${b.id}</id>`;

  return `<${proprtyName}>${info}</${proprtyName}>`;
}

export class NewMessageRequest extends BaseRequest implements INewMessageRequest {
  numberOfAttachments?: number;
  identity?: string;
  priority?: number;
  customType?: number;
  type?: number;
  mailFrom?: string;
  mailId?: string;
  templateAclh?: string;
  treeHandle?: number;
  group?: string;
  parent?: string;
  mobile?: string;
  status?: string;
  doNotMoveThread?: string;
  isSpam?: string;
  star?: string;
  threadId?: string;
  contextId?: string;
  remoteId?: string;
  schedulerId?: number;
  invoiceId?: string;
  INCLUDEMSG?: Includemsg;
  SUBJECT?: Comment;
  RECIPIENT?: Recipient;
  COMMENT?: Comment;
  HTML?: Comment;
  DOCUMENT?: Document;
  CONTACT_RELATIONS?: ContactRelations;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.numberOfAttachments = otherOptions.numberOfAttachments;
    this.identity = otherOptions.identity;
    this.priority = otherOptions.priority;
    this.customType = otherOptions.customType;
    this.type = otherOptions.type;
    this.mailFrom = otherOptions.mailFrom;
    this.mailId = otherOptions.mailId;
    this.templateAclh = otherOptions.templateAclh;
    this.treeHandle = otherOptions.treeHandle;
    this.group = otherOptions.group;
    this.parent = otherOptions.parent;
    this.mobile = otherOptions.mobile;
    this.status = otherOptions.status;
    this.doNotMoveThread = otherOptions.doNotMoveThread;
    this.isSpam = otherOptions.isSpam;
    this.star = otherOptions.star;
    this.threadId = otherOptions.threadId;
    this.contextId = otherOptions.contextId;
    this.remoteId = otherOptions.remoteId;
    this.schedulerId = otherOptions.schedulerId;
    this.invoiceId = otherOptions.invoiceId;
    this.INCLUDEMSG = otherOptions.INCLUDEMSG;
    this.SUBJECT = otherOptions.SUBJECT;
    this.RECIPIENT = otherOptions.RECIPIENT;
    this.COMMENT = otherOptions.COMMENT;
    this.HTML = otherOptions.HTML;
    this.DOCUMENT = otherOptions.DOCUMENT;
    this.CONTACT_RELATIONS = otherOptions.CONTACT_RELATIONS;
  }

  public toXml(): string {
    let parameters: string = super.toXml();

    parameters += this.makeNode(this.numberOfAttachments, 'numberOfAttachments');
    parameters += this.makeNode(this.identity, 'identity');
    parameters += this.makeNode(this.priority, 'priority');
    parameters += this.makeNode(this.customType, 'customType');
    parameters += this.makeNode(this.type, 'type');
    parameters += this.makeNode(this.mailFrom, 'mailFrom');
    parameters += this.makeNode(this.mailId, 'mailId');
    parameters += this.makeNode(this.templateAclh, 'templateAclh');
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.group, 'group');
    parameters += this.makeNode(this.parent, 'parent');
    parameters += this.makeNode(this.mobile, 'mobile');
    parameters += this.makeNode(this.status, 'status');
    parameters += this.makeNode(this.doNotMoveThread, 'doNotMoveThread');
    parameters += this.makeNode(this.isSpam, 'isSpam');
    parameters += this.makeNode(this.star, 'star');
    parameters += this.makeNode(this.threadId, 'threadId');
    parameters += this.makeNode(this.contextId, 'contextId');
    parameters += this.makeNode(this.remoteId, 'remoteId');
    parameters += this.makeNode(this.schedulerId, 'schedulerId');
    parameters += this.makeNode(this.invoiceId, 'invoiceId');
    if (this.INCLUDEMSG) parameters += toIncludemsgXml(this.INCLUDEMSG);
    if (this.SUBJECT) parameters += toCommentXml(this.SUBJECT, 'SUBJECT');
    if (this.RECIPIENT) parameters += toRecipientXml(this.RECIPIENT);
    if (this.COMMENT) parameters += toCommentXml(this.COMMENT, 'COMMENT');
    if (this.HTML) parameters += toCommentXml(this.HTML, 'HTML');
    if (this.DOCUMENT) parameters += toDocumentXml(this.DOCUMENT);
    if (this.CONTACT_RELATIONS) parameters += toContactRelationsXml(this.CONTACT_RELATIONS);

    return super.wrapperXml('NewMessage', parameters);
  }
}
